import { __assign, __spreadArray } from "tslib";
import React from 'react';
import { WrapperInnerTable } from './wrapper-inner-table';
export function Wrapper(props) {
    var backgroundColor = props.backgroundColor, _a = props.backgroundPosition, backgroundPosition = _a === void 0 ? 'top center' : _a, _b = props.backgroundRepeat, backgroundRepeat = _b === void 0 ? 'repeat' : _b, _c = props.backgroundSize, backgroundSize = _c === void 0 ? 'auto' : _c, backgroundUrl = props.backgroundUrl, children = props.children, controls = props.controls, cssClass = props.cssClass, _d = props.padding, padding = _d === void 0 ? '20px 0' : _d;
    var background = backgroundUrl
        ? {
            background: getBackground({
                backgroundColor: backgroundColor,
                backgroundUrl: backgroundUrl,
                backgroundSize: backgroundSize,
                backgroundRepeat: backgroundRepeat,
                backgroundPosition: backgroundPosition,
            }),
            // background size, repeat and position has to be seperate since yahoo does not support shorthand background css property
            backgroundPosition: getBackgroundPosition({ backgroundPosition: backgroundPosition }),
            backgroundRepeat: backgroundRepeat,
            backgroundSize: backgroundSize,
            width: '100%',
        }
        : {
            background: backgroundColor,
            width: '100%',
            backgroundColor: backgroundColor,
        };
    var attributes = backgroundUrl
        ? {}
        : {
            width: '100%',
            bgcolor: background.backgroundColor,
        };
    return (React.createElement("table", __assign({ align: "center", className: cssClass, background: backgroundUrl, border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: __assign({}, background) }, attributes),
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", null,
                    controls,
                    React.createElement(WrapperInnerTable, { backgroundColor: backgroundColor, backgroundUrl: backgroundUrl, padding: padding }, children))))));
}
function getBackgroundPosition(_a) {
    var backgroundPosition = _a.backgroundPosition;
    var _b = parseBackgroundPosition({ backgroundPosition: backgroundPosition }), x = _b.x, y = _b.y;
    return "".concat(x, " ").concat(y);
}
function parseBackgroundPosition(_a) {
    var backgroundPosition = _a.backgroundPosition;
    var posSplit = backgroundPosition.split(' ');
    if (posSplit.length === 1) {
        var val = posSplit[0];
        // here we must determine if x or y was provided ; other will be center
        if (['top', 'bottom'].includes(val)) {
            return {
                x: 'center',
                y: val,
            };
        }
        return {
            x: val,
            y: 'center',
        };
    }
    if (posSplit.length === 2) {
        // x and y can be put in any order in background-position so we need to determine that based on values
        var val1 = posSplit[0];
        var val2 = posSplit[1];
        if (['top', 'bottom'].includes(val1) ||
            (val1 === 'center' && ['left', 'right'].includes(val2))) {
            return {
                x: val2,
                y: val1,
            };
        }
        return {
            x: val1,
            y: val2,
        };
    }
    // more than 2 values is not supported, let's treat as default value
    return { x: 'center', y: 'top' };
}
function getBackground(_a) {
    var backgroundColor = _a.backgroundColor, backgroundUrl = _a.backgroundUrl, backgroundSize = _a.backgroundSize, backgroundRepeat = _a.backgroundRepeat, backgroundPosition = _a.backgroundPosition;
    return (__spreadArray([
        backgroundColor
    ], (backgroundUrl
        ? [
            "url('".concat(backgroundUrl, "')"),
            getBackgroundPosition({ backgroundPosition: backgroundPosition }),
            "/ ".concat(backgroundSize),
            backgroundRepeat,
        ]
        : []), true).filter(function (_) { return _; })
        .join(' ') || undefined);
}
//# sourceMappingURL=wrapper.js.map